import { render } from "./SidebarLayout.vue?vue&type=template&id=6a1776dc&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"

import "./SidebarLayout.vue?vue&type=style&index=0&id=6a1776dc&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1776dc"]])

export default __exports__